import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const services = [
  {
    num: '01',
    title: 'LANDING PAGE',
    desc: 'La puerta de entrada digital a tu negocio. Diseñada para captar la atención inmediata de los visitantes con una experiencia simplificada y persuasiva.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="2" y="3" width="20" height="14" rx="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
  },
  {
    num: '02',
    title: 'TIENDA EN LÍNEA',
    desc: 'Simplifica la experiencia de compra en línea, desde la navegación hasta el pago seguro. Una solución integral para exhibir y vender tus productos.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" />
        <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
      </svg>
    ),
  },
  {
    num: '03',
    title: 'PLATAFORMA WEB',
    desc: 'Una experiencia integral, desde la presentación de información hasta la interacción eficiente. Versatilidad y funcionalidad para tu presencia digital.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" />
      </svg>
    ),
  },
  {
    num: '04',
    title: 'APPS MÓVILES',
    desc: 'Desarrollo de aplicaciones nativas y multiplataforma que llevan tu negocio al bolsillo de tus clientes con experiencias fluidas e intuitivas.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12" y2="18.01" strokeWidth="2" />
      </svg>
    ),
  },
  {
    num: '05',
    title: 'MARKETING DIGITAL',
    desc: 'Campañas respaldadas por datos a través de medios pagados, orgánicos y redes sociales — diseñadas para adquirir, retener y expandir tu base de clientes ideales.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M3 20h18" />
        <path d="M6 20v-4" />
        <path d="M10 20v-8" />
        <path d="M14 20v-11" />
        <path d="M18 20v-15" />
        <path d="M14 5l4 0l0 4" />
        <path d="M6 16l4-4l4 1l4-8" />
      </svg>

    ),
  },
  {
    num: '06',
    title: 'CREACIÓN DE CONTENIDO',
    desc: 'Contenido estratégico que te posiciona como una autoridad — desde publicaciones de blog optimizadas para SEO hasta guiones de video, todo alineado con tu embudo de ventas.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="8" y1="13" x2="16" y2="13" />
        <line x1="8" y1="17" x2="14" y2="17" />
        <path d="M16 3l4 4" />
      </svg>

    ),
  },
];

const ServiceCard = ({ num, title, desc, icon, onClick }) => {
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    const rect = cardRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    cardRef.current.style.transform = `translateY(-8px) perspective(600px) rotateX(${y * -5}deg) rotateY(${x * 5}deg)`;
  };

  const handleMouseLeave = () => {
    cardRef.current.style.transform = 'translateY(0) perspective(600px) rotateX(0) rotateY(0)';
  };

  return (
    <div
      className="service-card reveal"
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      <div className="service-card__number">{num}</div>
      <div className="service-card__icon">{icon}</div>
      <h3 className="service-card__title">{title}</h3>
      <p className="service-card__desc">{desc}</p>
      <button className="service-card__link" aria-label={`Ver más sobre ${title}`}>
        Ver más
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

const Services = () => {
  const navigate = useNavigate();

  return (
    <section className="services" id="servicios">
      <div className="services__header reveal">
        <div className="section-label">Nuestros Servicios</div>
        <h2 className="section-title">LO QUE<br />HACEMOS</h2>
        <div className="section-sub">
          Ofrecemos una gama completa de servicios diseñados para impulsar tu presencia en línea.
        </div>
      </div>
      <div className="services__grid">
        {services.map((s) => (
          <ServiceCard key={s.num} {...s} onClick={() => navigate('/contacto')} />
        ))}
      </div>
    </section>
  );
};

export default Services;
